export default "__VITE_ASSET__6f722321__"